/**
 * Идентификатор сообщения в Telegram.
 *
 * `id` в выдаче бывает двух видов: `tg:<n>` у сообщений, пришедших из TDLib,
 * и наш UUID у тех, что ушли через систему. Сервер на прочтении, ответе,
 * закреплении, реакциях, пересылке, правке, удалении и вложениях ждёт
 * именно номер Telegram — UUID там либо не проходит валидацию (400), либо
 * уходит в TDLib как номер и ничего не находит. Поэтому сперва
 * `telegramMessageId`, и только без него — разбор префикса.
 *
 * null — сообщение ещё не получило номер в Telegram (например, отправка в
 * пути): действовать над ним в Telegram нечем.
 */
export function telegramIdOf(message: {
  id: string;
  telegramMessageId?: string | null;
}): string | null {
  if (message.telegramMessageId) return message.telegramMessageId;
  return message.id.startsWith("tg:") ? message.id.slice(3) : null;
}

/** Одно ли это сообщение — по нашему id или по номеру в Telegram. */
export function sameMessage(
  a: { id: string; telegramMessageId?: string | null },
  b: { id: string; telegramMessageId?: string | null },
): boolean {
  if (a.id === b.id) return true;
  const ta = telegramIdOf(a);
  return ta !== null && ta === telegramIdOf(b);
}
